/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_SavingInputs */

const en_story_bank_saving = /** @type {(inputs: Story_Bank_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const de_story_bank_saving = /** @type {(inputs: Story_Bank_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const fr_story_bank_saving = /** @type {(inputs: Story_Bank_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const es_story_bank_saving = /** @type {(inputs: Story_Bank_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const it_story_bank_saving = /** @type {(inputs: Story_Bank_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const nl_story_bank_saving = /** @type {(inputs: Story_Bank_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const pl_story_bank_saving = /** @type {(inputs: Story_Bank_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const fi_story_bank_saving = /** @type {(inputs: Story_Bank_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const da_story_bank_saving = /** @type {(inputs: Story_Bank_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const sv_story_bank_saving = /** @type {(inputs: Story_Bank_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

/**
* | output |
* | --- |
* | "Saving..." |
*
* @param {Story_Bank_SavingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_saving = /** @type {((inputs?: Story_Bank_SavingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_SavingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_saving(inputs)
	if (locale === "fr") return fr_story_bank_saving(inputs)
	if (locale === "es") return es_story_bank_saving(inputs)
	if (locale === "it") return it_story_bank_saving(inputs)
	if (locale === "nl") return nl_story_bank_saving(inputs)
	if (locale === "pl") return pl_story_bank_saving(inputs)
	if (locale === "fi") return fi_story_bank_saving(inputs)
	if (locale === "da") return da_story_bank_saving(inputs)
	if (locale === "sv") return sv_story_bank_saving(inputs)
	return en_story_bank_saving(inputs)
});